<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <div class="row mb-3">
        <div class="col-sm-8"><h4 class="mb-0">PM V2 - تجهیزات دارای موارد آماده اجرا</h4></div>

      </div>

      <form class="card card-statistics mb-30" [formGroup]="FilterForm" (ngSubmit)="ReadData()">
        <div class="card-body">
          <div class="row">
            <div class="col-md-4 form-group">
              <label>عنوان قالب</label>
              <input type="text" class="form-control" formControlName="TemplateTitle" placeholder="جستجو در عنوان قالب PM">
            </div>
            <div class="col-md-2 form-group">
              <label>وضعیت</label>
              <select class="custom-select" formControlName="Active">
                <option [ngValue]="true">فعال</option>
                <option [ngValue]="false">غیرفعال</option>
              </select>
            </div>
            <div class="col-md-3 form-group">
              <label>گروه تجهیز</label>
              <select class="custom-select" formControlName="GroupId" (change)="ReadSubGroups()">
                <option [ngValue]="0">همه موارد</option>
                <option *ngFor="let group of GroupList" [ngValue]="group.id">{{ group.title }}</option>
              </select>
            </div>
            <div class="col-md-3 form-group">
              <label>زیرگروه تجهیز</label>
              <select class="custom-select" formControlName="SubGroupId" [disabled]="FilterForm.get('GroupId')?.value === 0">
                <option [ngValue]="0">همه موارد</option>
                <option *ngFor="let subGroup of SubGroupList" [ngValue]="subGroup.id">{{ subGroup.title }}</option>
              </select>
            </div>
            <div class="col-md-4 form-group">
              <label>کلیدواژه تجهیز</label>
              <input type="text" class="form-control" formControlName="Keyword" placeholder="کد BEHFA، شرح، سازنده یا مدل">
            </div>
            <div class="col-md-4 form-group">
              <label>بازه زمانی سررسید</label>
              <select class="custom-select" formControlName="DueWindow">
                <option value="overdue">گذشته از سررسید</option>
                <option value="today">سررسید امروز</option>
                <option value="upcoming">تا یک هفته آینده</option>
                <option value="all">همه موارد مرتبط</option>
              </select>
            </div>
            <div class="col-md-4 form-group pt-4">
              <button type="submit" class="btn btn-info" [disabled]="Procssing"><i class="fa fa-search"></i> جستجو</button>
            </div>
          </div>
        </div>
      </form>

      <div *ngIf="Procssing" class="text-center p-3">در حال دریافت اطلاعات...</div>
      <div class="table-responsive" *ngIf="!Procssing">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color:#489b39;color:white">
            <tr><th>#</th><th>تجهیز</th><th>کد تجهیز</th><th>گروه</th><th>قالب PM</th><th>تعداد آیتم آماده اجرا</th><th>امکانات</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList | paginate: { id: 'DueEquipmentList', itemsPerPage: 50, currentPage: page, totalItems: DataList.length }; let i=index">
              <td>{{ ((page - 1) * 50) + i + 1 }}</td>
              <td>{{ item.Equipment_Name || '-' }}<br><small>{{ item.Equipment_Model || '-' }}</small></td>
              <td><strong>{{ item.Equipment_Code || '-' }}</strong></td>
              <td>{{ item.Group || '-' }}<br><small>{{ item.SubGroup || '-' }}</small></td>
              <td><strong>{{ item.Template_Code }}</strong><br>{{ item.Template_Name }}</td>
              <td><span class="badge badge-warning">{{ item.Due_Item_Count }}</span></td>
              <td><button type="button" class="btn btn-info" (click)="Detail(item)">جزئیات</button></td>
            </tr>
            <tr *ngIf="DataList.length === 0"><td colspan="7">تجهیز دارای PM آماده اجرا وجود ندارد.</td></tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DueEquipmentList" nextLabel="بعدی" previousLabel="قبلی" (pageChange)="page = $event"></pagination-controls>
  </div>
</div>
